/**
 * Feedback Inbox is Nexora's view of notes members send.
 * The signed-in provider, account email, and user id do not grant it.
 * The active organization must be Nexora Systems, and that membership
 * must be owner or admin. Another organization's admin does not qualify.
 */

import { isGuestActor } from "../helpers/guestMode";
import { MEMBERSHIP_ROLE } from "../helpers/membershipHelpers";
import { NEXORA_OPERATIONS_ORGANIZATION_ID } from "../helpers/nexoraOpsAccess";

export const FEEDBACK_INBOX_SCREEN = "feedback_inbox";

function isNexoraOwnerOrAdmin(actor) {
  const membershipRole = actor.membership_role;
  if (
    membershipRole === MEMBERSHIP_ROLE.OWNER ||
    membershipRole === MEMBERSHIP_ROLE.ADMIN
  ) {
    return true;
  }
  if (membershipRole) {
    return false;
  }
  return actor.role === "admin";
}

export function actorCanAccessFeedbackInbox(actor) {
  if (!actor || isGuestActor(actor)) {
    return false;
  }
  if (actor.organization_id !== NEXORA_OPERATIONS_ORGANIZATION_ID) {
    return false;
  }
  return isNexoraOwnerOrAdmin(actor);
}
